<template>
  <!-- 会员管理（布局对齐通证互转等页：横向查询 + 斑马纹表格） -->
  <div class="service member-page">
    <el-form :inline="true" :model="form" class="demo-form-inline member-filter-form">
      <el-form-item label="注册时间">
        <el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" style="width: 260px">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="手机号码">
        <el-input v-model="form.phone" placeholder="请输入电话" clearable style="width: 140px" />
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="form.userId" placeholder="请输入用户ID" clearable style="width: 130px" />
      </el-form-item>
      <el-form-item label="钱包地址">
        <el-input v-model="form.wallet" placeholder="钱包地址" clearable style="width: 180px" />
      </el-form-item>
      <el-form-item label="用户状态">
        <el-select v-model="form.status" placeholder="全部" clearable style="width: 130px">
          <el-option v-for="item in userStatus" :key="item.label" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="doFilter">查询</el-button>
        <el-button type="primary" @click="onRest">重置</el-button>
        <download-excel v-if="derivedForm" class="export export-excel" :data="derivedForm" :fields="jsonFields"
          type="xls" name="用户表单.xls" header="用户列表">
          导出
        </download-excel>
        <el-button type="warning" plain style="margin-left: 12px" @click="onAllRock">全部锁仓</el-button>
        <el-button type="warning" plain @click="onAllRockFalse">清仓</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table :data="dataUser" stripe border style="width: 100%"
        :row-class-name="(({ row }) => row.isRed == 2 ? 'el-table_row-red' : '')">
          <el-table-column prop="id" label="会员Id" width="100" align="center"> </el-table-column>
          <el-table-column label="姓名" prop="trueName" align="center" min-width="80"></el-table-column>
          <el-table-column prop="parentId" label="推荐人UID" width="100" align="center"> </el-table-column>
          <el-table-column prop="tel" label="手机号" width="150" align="center"> </el-table-column>
          <el-table-column prop="walletArea" label="钱包地址" width="" align="center"> </el-table-column>
          <el-table-column prop="closeAmount2" label="锁仓金额" width="" align="center"> </el-table-column>
          <!-- <el-table-column prop="inviteTel" label="邀请人(手机)" width="" align="center">
            <template slot-scope="scope">
              {{ scope.row.inviteTel || '暂无' }}
            </template>
          </el-table-column> -->
          <el-table-column prop="createTime" label="注册时间" width="" align="center"> </el-table-column>
          <el-table-column label="认证等级" min-width="100" align="center">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.authen == 1 ? 'success' : scope.row.authen == 2 ? 'primary' : 'info'"
                class="member-tag-click" @click.native="toView(scope.row)">
                {{ scope.row.authen == 1 ? '初级认证' : scope.row.authen == 2 ? '高级认证' : '未认证' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="数字通证" align="center" width="88">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="through(scope.row.id)">查看</el-button>
            </template>
          </el-table-column>
          <!--   <el-table-column
            label="CNY"
            prop="balance"
            width="100"
          ></el-table-column> -->
          <el-table-column label="推荐人数" width="88" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.inviteNum != null ? scope.row.inviteNum : 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">正常</span>
              <span v-if="scope.row.status == 1">系统冻结</span>
              <span v-if="scope.row.status == 2">密码错误上限冻结</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="200">
            <template slot-scope="scope">
              <div class="member-op-row">
                <el-button-group>
                  <el-button size="mini" :type="!scope.row.status ? 'danger' : 'success'"
                    @click="onStatus(scope.row.id, scope.row.status, scope.$index)">
                    {{ !scope.row.status ? '锁定' : '解锁' }}
                  </el-button>
                  <el-button size="mini" type="danger" @click="onRock(scope.row.id)">锁仓</el-button>
                  <el-button size="mini" type="success" @click="onRockFalse(scope.row.id)">解仓</el-button>
                </el-button-group>
                <el-dropdown trigger="click" @command="cmd => handleMemberOp(cmd, scope.row, scope.$index)">
                  <el-button size="mini" type="primary">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="tel">修改手机号</el-dropdown-item>
                    <el-dropdown-item command="info">查看个人信息</el-dropdown-item>
                    <el-dropdown-item command="gen">查看GEN信息</el-dropdown-item>
                    <el-dropdown-item command="parent">修改推荐人ID</el-dropdown-item>
                    <el-dropdown-item command="cert">通证绑定</el-dropdown-item>
                    <el-dropdown-item command="cnyMes">查看CNY统计信息</el-dropdown-item>
                    <el-dropdown-item command="mark" divided>
                      {{ scope.row.isRed == 1 ? '标记' : '取消标记' }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30]" :page-size="pageNumber" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="YHSZ信息" :visible.sync="showTag2" width="50%">
        <div>
          <el-select v-model="tzValue" placeholder="请选择通证">
            <el-option v-for="item in tongOptions" :key="item.id" :label="item.tokenName" :value="item.id">
            </el-option>
          </el-select>
          <div>
            <p>原价钰芸数证:{{ GenInfo.old.totalAmount }}</p>
            <p>可用余额:{{ GenInfo.old.amount }}</p>
            <p>冻结余额:{{ GenInfo.old.closeAmount }}</p>
            <p v-for="(item, i) in GenInfo.old.list" :key='i'>已锁仓{{ item.day }}数:{{ item.num }}个</p>

            <p style="margin-top:40px">特价钰芸数证:{{ GenInfo.agreement.totalAmount }}</p>
            <p>可用余额:{{ GenInfo.agreement.amount }}</p>
            <p>冻结余额:{{ GenInfo.agreement.closeAmount }}</p>
            <p v-for="(item, i) in GenInfo.agreement.list" :key='i'>已锁仓{{ item.day }}数:{{ item.num }}个</p>

          </div>
        </div>
      </el-dialog>
      <!-- 弹出框 -->
      <el-dialog title="会员信息" :visible.sync="showTag" width="50%">
        <div class="tanchukuang" v-if="userInfo">
          <div>
            <div>
              <span>会员ID：</span>
              <span>{{ userInfo.id }}</span>
            </div>
            <div>
              <span>手机号码：</span>
              <span>{{ userInfo.tel }}</span>
            </div>
          </div>
          <div>
            <div>
              <span>邀请人：</span>
              <span>{{ userInfo.inviteTel }}</span>
            </div>
            <div>
              <span>注册时间：</span>
              <span>{{ userInfo.createTime }}</span>
            </div>
          </div>
          <div>
            <div>
              <span>会员等级：</span>
              <span>{{ userInfo.authen == 1 ? '初级认证' : userInfo.authen ? '高级认证' : '未认证' }}</span>
            </div>
            <div>
              <span>姓名：</span>
              <span>{{ userInfo.trueName }}</span>
            </div>
          </div>
          <div>
            <div>
              <span>身份证号码：</span>
              <span>{{ userInfo.idCard }}</span>
            </div>
            <!-- <div>
              <span>微信账号：</span>
              <span>{{userInfo.}}</span>
            </div> -->
          </div>
          <!-- <div>
            <div>
              <span>银行卡：</span>
              <span>1231321</span>
            </div>
            <div>
              <span>支付宝账号：</span>
              <span>1231321</span>
            </div>
          </div>
          <div>
            <div>
              <span>预留手机号：</span>
              <span>1231321</span>
            </div>
          </div> -->
        </div>
      </el-dialog>
      <!-- 查看通证弹出框 -->
      <el-dialog title="通证信息" :visible.sync="seeValue" width="50%">
        <el-table :data="passCard.data" style="padding: 20px">
          <el-table-column label="通证名字" prop="tokenName">
            <template slot-scope="scope">
              {{ scope.row.certificateId == 0 ? 'CNY' : scope.row.tokenName }}
            </template>
          </el-table-column>
          <el-table-column label="通证数量" prop="num"></el-table-column>
          <el-table-column label="冻结数量" prop="closeNum">
            <template slot-scope="scope">
              {{ scope.row.certificateId == 0 ? scope.row.closeAmount : scope.row.closeNum }}
            </template>
          </el-table-column>
          <el-table-column label="CND余额">
            <template slot-scope="scope">
              {{ scope.row.cnd || 0 }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="ThandleSizeChange" @current-change="ThandleCurrentChange"
          :current-page="passCard.currentPage" :page-sizes="[10, 15, 20, 30]" :page-size="passCard.pageNumber"
          layout="total, sizes, prev, pager, next, jumper" :total="passCard.total" style="margin: 20px 0 20px 50px">
        </el-pagination>
      </el-dialog>
      <!-- 认证信息弹窗 -->
      <el-dialog title="会员认证信息" :visible.sync="userPopup">
        <el-form v-if="certification" :model="certification" label-width="100px" class="users">
          <el-form-item label="会员ID">
            <span>{{ certification.userId }}</span>
          </el-form-item>
          <el-form-item label="姓名">
            <span>{{ certification.name }}</span>
          </el-form-item>
          <el-form-item label="身份证号">
            <span>{{ certification.cardNum }}</span>
          </el-form-item>
          <el-form-item label="电话">
            <span>{{ certification.tel }}</span>
          </el-form-item>

          <el-form-item label="认证状态">
            <el-tag size="mini" effect="dark" :type="certification.grade == 1 ? 'success' : 'primary'">{{
              certification.grade == 1 ? '初级认证' : '高级认证'
            }}</el-tag>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-tag size="mini" effect="dark"
              :type="certification.status == 1 ? 'success' : certification.status == 2 ? 'danger' : 'warning'">{{
                certification.status == 1 ? '审核通过' : certification.status == 2 ? '审核失败' : '未审核' }}</el-tag>
          </el-form-item>
          <el-form-item label="手持身份证">
            <el-image :src="certification.cardImage" fit="scale-down" style="width: 200px; height: 200px"></el-image>
          </el-form-item>
          <el-form-item label="身份证正面">
            <el-image :src="certification.cardFront" fit="scale-down" style="width: 200px; height: 200px"></el-image>
          </el-form-item>
          <el-form-item label="身份证反面">
            <el-image :src="certification.cardAfter" fit="scale-down" style="width: 200px; height: 200px"></el-image>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="通证绑定" :visible.sync="certificateInfo.show" width="400px">
        <el-form>
          <el-form-item label="通证">
            <el-select v-model="certificateInfo.certificateId">
              <el-option v-for="item in certificateInfo.list" :key="item.id" :value="item.id"
                :label="item.tokenName"></el-option>
            </el-select>
          </el-form-item>
          <el-row style="width:100%;justify-content: center;display: flex;">
            <el-button size="mini" type="primary" style="margin-top:20px" @click="updateCertificate">确定</el-button>
          </el-row>
        </el-form>
      </el-dialog>
      <el-dialog title="修改手机号" :visible.sync="updateTelDialog.show" width="420px" @closed="onUpdateTelDialogClosed">
        <el-form label-width="100px" size="small">
          <el-form-item label="会员ID">
            <span>{{ updateTelDialog.userId }}</span>
          </el-form-item>
          <el-form-item label="当前手机号">
            <span>{{ updateTelDialog.oldTel || '—' }}</span>
          </el-form-item>
          <el-form-item label="新手机号" required>
            <el-input v-model="updateTelDialog.newTel" placeholder="请输入11位新手机号" maxlength="11" clearable
              @keyup.enter.native="submitUpdateTel" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="updateTelDialog.show = false">取 消</el-button>
          <el-button type="primary" :loading="updateTelDialog.loading" @click="submitUpdateTel">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="用户CNY统计信息" :visible.sync="userCnyMesDialog.show" width="900px">
        <div class="user-cny-mes-panel">
          <div class="user-cny-id-line">
            <span>会员ID：</span>
            <span>{{ userCnyMesDialog.userId }}</span>
          </div>
          <div class="user-cny-mes-grid">
            <div class="user-cny-mes-cell">CNY余额:</div>
            <div class="user-cny-mes-cell">冻结CNY</div>
            <div class="user-cny-mes-cell">提现金额:</div>
            <div class="user-cny-mes-cell">转出CNY金额:</div>
            <div class="user-cny-mes-cell">充值金额:</div>
            <div class="user-cny-mes-cell">接收CNY金额</div>
          </div>
          <div class="user-cny-mes-grid user-cny-mes-values">
            <div class="user-cny-mes-cell">{{ formatCnyMesValue(userCnyMesDialog.data.num) }}</div>
            <div class="user-cny-mes-cell">{{ formatCnyMesValue(userCnyMesDialog.data.closeAmount) }}</div>
            <div class="user-cny-mes-cell">{{ formatCnyMesValue(userCnyMesDialog.data.withdrawAmount) }}</div>
            <div class="user-cny-mes-cell">{{ formatCnyMesValue(userCnyMesDialog.data.transferAmount) }}</div>
            <div class="user-cny-mes-cell">{{ formatCnyMesValue(userCnyMesDialog.data.topAmount) }}</div>
            <div class="user-cny-mes-cell">{{ formatCnyMesValue(userCnyMesDialog.data.getAmount) }}</div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        time: '', // 时间
        phone: '', // 电话
        trueName: '', // 姓名
        approve: '',
        userId: '',
        wallet: '',
        status: null
      },
      dataUser: null,
      total: null,
      currentPage: 1,
      pageNumber: null,
      showTag: false,
      showTag2: false,
      seeValue: false,
      userPopup: false, // 用户认证信息弹窗
      tzValue: '',
      // 数字通证
      passCard: {
        total: null,
        data: null,
        currentPage: 1,
        pageNumber: 10,
        userId: null
      },
      // 用户信息
      userInfo: null,
      userId: '',
      derivedForm: '', //导出的表格数据
      // 导出表单的格式
      jsonFields: {
        ID: 'id',
        姓名: 'trueName',
        电话: 'tel',
        身份证号码: 'idCard',
        推荐人数: 'inviteNum',
        累计邀请有效用户数: 'inviteUser',
        邀请人电话: 'inviteTel',
        可提现余额: 'balance',
        冻结金额: 'closeAmount',
        注册时间: 'createTime',
        认证: 'authen'
      },
      certification: {}, // 用户认证信息
      // 认证等级
      attestation: [
        {
          value: 2,
          label: '高级'
        },
        {
          value: 1,
          label: '初级'
        },
        {
          value: 0,
          label: '未认证'
        }
      ],
      // 冻结状态
      userStatus: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 0,
          label: '正常'
        },
        {
          value: 1,
          label: '系统冻结'
        },
        {
          value: 2,
          label: '密码错误冻结'
        }
      ],
      tongOptions: [],
      GenInfo: { old: { list: [] }, agreement: { list: [] } },
      certificateInfo: {
        list: [],
        userId: '',
        certificateId: '',
        show: false
      },
      updateTelDialog: {
        show: false,
        userId: null,
        oldTel: '',
        newTel: '',
        loading: false
      },
      userCnyMesDialog: {
        show: false,
        userId: null,
        data: {
          num: 0,
          closeAmount: 0,
          withdrawAmount: 0,
          transferAmount: 0,
          topAmount: 0,
          getAmount: 0
        }
      }
    }
  },
  created() {
    this.onMenber()
    this.getTongz()
    this.getCertificate()
    // 获取所有的数据
    // this.axios.get("/admin/user/userExcel", {}).then((res) => {
    //   this.derivedForm = res.data.data;
    //   this.derivedForm.forEach((item) => {
    //     item.authen =
    //       item.authen == 1
    //         ? "初级认证"
    //         : item.authen == 2
    //         ? "高级认证"
    //         : "未认证";
    //   });
    // });
  },
  methods: {
    // 获取数字通证
    getCertificate() {
      this.axios
        .get("/admin/certificate/findAll", {
          currentPage: 1,
          pageSize: 999,
        })
        .then((res) => {
          console.log(res);
          this.certificateInfo.list = res.data.data.records.filter(e => e.id !== 0);
        });
    },
    // 绑定数字通证
    updateCertificate() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios.get('/admin/user/updateCertificate', {
        userId: this.certificateInfo.userId,
        certificateId: this.certificateInfo.certificateId,
      })
        .then(res => {
          loading.close()
          this.certificateInfo.show = false
          this.$message({
            message: '操作成功!',
            type: 'success'
          })
          this.handleCurrentChange(this.currentPage)
        })
    },
    getTongz() {
      this.axios.get('/admin/gen/findAll')
        .then(res => {
          this.tongOptions = res.data.data.records
          this.tzValue = this.tongOptions[0].id
        })
    },
    handleMemberOp(cmd, row, index) {
      switch (cmd) {
        case 'tel':
          this.openUpdateTel(row)
          break
        case 'info':
          this.handleDelete(index, row.id)
          break
        case 'gen':
          this.handleDelete2(row.id)
          break
        case 'parent':
          this.updateParentId(row.id)
          break
        case 'cnyMes':
          this.getUserCnyMes(row.id)
          break
        case 'cert':
          this.certificateInfo.certificateId = row.certificateId
          this.certificateInfo.userId = row.id
          this.certificateInfo.show = true
          break
        case 'mark':
          this.handleMark(row)
          break
        default:
          break
      }
    },
    openUpdateTel(row) {
      this.updateTelDialog.userId = row.id
      this.updateTelDialog.oldTel = row.tel || ''
      this.updateTelDialog.newTel = ''
      this.updateTelDialog.show = true
    },
    onUpdateTelDialogClosed() {
      this.updateTelDialog.userId = null
      this.updateTelDialog.oldTel = ''
      this.updateTelDialog.newTel = ''
      this.updateTelDialog.loading = false
    },
    submitUpdateTel() {
      const newTel = (this.updateTelDialog.newTel || '').trim()
      if (!newTel) {
        this.$message.warning('请输入新手机号')
        return
      }
      if (!/^1\d{10}$/.test(newTel)) {
        this.$message.warning('请输入11位有效手机号')
        return
      }
      this.updateTelDialog.loading = true
      this.axios
        .get('/admin/user/updateTel', {
          userId: this.updateTelDialog.userId,
          newTel
        })
        .then(res => {
          this.updateTelDialog.loading = false
          if (res.data.code == 200) {
            this.$message.success('手机号修改成功')
            const uid = this.updateTelDialog.userId
            this.updateTelDialog.show = false
            if (this.dataUser && Array.isArray(this.dataUser)) {
              const row = this.dataUser.find(u => u.id === uid)
              if (row) row.tel = newTel
            }
            if (this.userInfo && this.userInfo.id === uid) {
              this.userInfo.tel = newTel
            }
          } else {
            this.$message.error(res.data.data || '修改失败')
          }
        })
        .catch(() => {
          this.updateTelDialog.loading = false
        })
    },
    formatCnyMesValue(value) {
      if (value === null || value === undefined || value === '') return 0
      return value
    },
    getUserCnyMes(id) {
      this.axios
        .get('/admin/user/getUserCnyMes', { id })
        .then(res => {
          if (res.data.code == 200) {
            const data = res.data.data || {}
            this.userCnyMesDialog.userId = id
            this.userCnyMesDialog.data = {
              num: data.num,
              closeAmount: data.closeAmount,
              withdrawAmount: data.withdrawAmount,
              transferAmount: data.transferAmount,
              topAmount: data.topAmount,
              getAmount: data.getAmount
            }
            this.userCnyMesDialog.show = true
          } else {
            this.$message.error(res.data.data || '查询CNY统计信息失败')
          }
        })
        .catch(() => {
          this.$message.error('查询CNY统计信息失败')
        })
    },
    // 搜索按钮
    doFilter() {
      const time = this.form.time
      const params = {
        tel: this.form.phone,
        userId: this.form.userId,
        wallet: this.form.wallet,
        status: this.form.status
      }
      if (time && time.length === 2 && time[0] && time[1]) {
        params.startTime = time[0]
        params.endTime = time[1]
      }
      this.axios
        .get('/admin/user/findAll', params)
        .then(res => {
          console.log(res)
          this.dataUser = res.data.data.records
          this.total = res.data.data.total
          this.pageNumber = res.data.data.size
          this.currentPage = res.data.data.current
        })
    },
    // 解锁status
    onStatus(id, status, index) {
      if (status) {
        this.axios
          .get('/admin/user/updateStatus', {
            userId: id,
            status: 0
          })
          .then(res => {
            console.log(res)
            this.dataUser[index].status = 0
            this.$message({
              message: '解锁成功!',
              type: 'success'
            })
          })
      } else {
        this.axios
          .get('/admin/user/updateStatus', {
            userId: id,
            status: 1
          })
          .then(res => {
            console.log(res)
            this.dataUser[index].status = 1
            this.$message({
              message: '锁定成功!',
              type: 'success'
            })
          })
      }
    },
    //修改推荐人ID
    updateParentId(id) {
      this.$prompt('请输入UID', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.axios.get('/admin/user/updateParentId', {
          parentId: value,
          id
        }).then(res => {
          this.doFilter()
          this.$message.success('修改成功')
        })
      }).catch(() => {

      });
    },
    // 锁仓rock
    onRockFalse(id) {
      this.axios
        .get('/admin/user/rockFalseUser', {
          userId: id
        })
        .then(res => {
          console.log(res)
          this.$message({
            message: res.data.data,
            type: 'success'
          })
        })
    },
    // 解锁rock
    onRock(id) {
      this.$prompt('请输入锁仓比例,最大为1（100%）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.axios
          .get('/admin/user/rockUser', {
            userId: id,
            rate: value
          })
          .then(res => {
            console.log(res)
            this.$message({
              message: '锁定成功!',
              type: 'success'
            })
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    // 解锁rock
    onAllRockFalse() {
      this.$confirm('确定清仓吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios
          .get('/admin/user/rockFalse', {
          })
          .then(res => {
            console.log(res)
            this.$message({
              message: res.data.data,
              type: 'success'
            })
          })
      }).catch(() => {

      })

    },
    // 锁仓rock
    onAllRock() {
      this.$confirm('此操作将全部用户锁仓, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.get('/admin/user/rock', {})
          .then(res => {
            console.log(res)
            this.$message({
              message: '锁定成功!',
              type: 'success'
            })
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 密码解锁
    // onStatusPwd(id) {
    //   this.axios
    //     .get("/admin/user/updateStatus", {
    //       status: 0,
    //       userId: id,
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       this.$message({
    //         message: "解锁密码成功!",
    //         type: "success",
    //       });
    //     })
    //     .catch((err) => {});
    // },

    // 会员管理接口
    onMenber() {
      this.axios.get('/admin/user/findAll', {}).then(res => {
        this.dataUser = res.data.data.records
        this.total = res.data.data.total
        this.pageNumber = res.data.data.size
        this.currentPage = res.data.data.current
      })
    },

    // 重置input框数据
    onRest() {
      this.form = {
        time: '',
        phone: '',
        trueName: '',
        approve: '',
        userId: '',
        wallet: '',
        status: null
      }
      this.currentPage = 1
      this.onMenber()
    },

    // 查看
    handleDelete(index, id) {
      this.showTag = true
      this.axios.get('/admin/user/findById', { id }).then(res => {
        if (res.data.code == 200) {
          this.userInfo = res.data.data
          console.log(this.userInfo)
        }
      })
    },
    //查看GEN
    handleDelete2(id) {
      this.userId = id
      this.getFindUserGen()
      this.showTag2 = true

    },
    // 标记
    handleMark(item) {
      const isRed = item.isRed == 1 ? 2 : 1
      this.axios.get('/admin/user/updateRed', { red: isRed, userId: item.id })
        .then(res => {
          item.isRed = isRed
        })
    },
    getFindUserGen() {
      this.axios.get('/admin/user/findUserGen', { genId: this.tzValue, userId: this.userId })
        .then(res => {
          this.GenInfo = res.data.data
        })
    },
    /**
     * 查看认证信息
     * @param {*} item
     */
    toView(item) {
      // console.log(item)
      if (item.authen === 0) {
        this.$message.warning('该用户未认证')
      } else {
        // 查看认证信息
        this.axios.get('/admin/user/findByUserId', { userId: item.id }).then(res => {
          this.userPopup = true
          this.certification = res.data.data
          console.log(this.certification)
        })
      }
    },

    // 分页
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageNumber = val
      this.axios
        .get('/admin/user/findAll', {
          pageNumber: this.currentPage,
          pageSize: this.pageNumber
        })
        .then(res => {
          // console.log(res.data.data);
          this.dataUser = res.data.data.records
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.axios
        .get('/admin/user/findAll', {
          currentPage: this.currentPage,
          pageSize: this.pageNumber
        })
        .then(res => {
          // console.log(res.data.data);
          this.dataUser = res.data.data.records
        })
    },
    // 查看数字通证
    through(userId) {
      this.passCard.userId = userId
      // /app/userCertificate/adminShow
      this.axios
        .get('/admin/user/getUserBalance', { id: this.passCard.userId })
        .then(res => {
          if (res.data.code == 200) {
            this.seeValue = true
            this.passCard.data = res.data.data.records
            this.passCard.total = res.data.data.total
            this.passCard.currentPage = res.data.data.current
            this.passCard.pageNumber = res.data.data.size
          }
        })
        .catch(err => { })
    },

    // 弹窗分页
    ThandleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.passCard.pageNumber = val
      this.axios
        .get('/app/userCertificate/adminShow', {
          pageNumber: this.passCard.currentPage,
          pageSize: this.passCard.pageNumber,
          userId: this.passCard.userId
        })
        .then(res => {
          // console.log(res.data.data);
          this.passCard.data = res.data.data.records
        })
    },
    ThandleCurrentChange(val) {
      this.passCard.currentPage = val
      this.axios
        .get('/app/userCertificate/adminShow', {
          currentPage: this.passCard.currentPage,
          pageSize: this.passCard.pageNumber,
          userId: this.passCard.userId
        })
        .then(res => {
          this.passCard.data = res.data.data.records
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  color: #fff;
  padding: 5px 10px;
  background-color: #409eff;
  border-radius: 10px;
}

.index .wrapper .memberInfo .cont h4[data-v-192e00bb] {
  text-rendering: optimizeLegibility;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  width: 110px;
  line-height: 28px;
  border-radius: 4px;
  text-align: center;
  background: #409eff;
  font-size: 16px;
  color: #fff;
  font-weight: lighter;
}

.left {
  text-rendering: optimizeLegibility;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  line-height: 16px;
  width: 50%;
  float: left;
}

.line {
  text-rendering: optimizeLegibility;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  width: 100%;
  margin: 20px 0;
  overflow: hidden;
  font-size: 16px;
  line-height: 16px;
}

.cont {
  text-rendering: optimizeLegibility;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  width: calc(100% - 60px);
  margin: 30px auto;
}

.wrapper {
  text-rendering: optimizeLegibility;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.memberInfo {
  text-rendering: optimizeLegibility;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 800px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
}

.text {
  font-size: 14px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 600px;
  height: 300px;
}

.member-filter-form {
  ::v-deep .el-form-item {
    margin-right: 8px;
    margin-bottom: 12px;
    vertical-align: middle;
  }

  ::v-deep .el-form-item__label {
    color: #606266;
    font-weight: normal;
    padding-right: 6px;
  }
}

.member-op-row {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.member-tag-click {
  cursor: pointer;
}

.export-excel {
  margin-left: 8px;
  background-color: #67c23a;
  border-color: #67c23a;
  color: #fff;
}

.export-excel:hover {
  opacity: 0.92;
  cursor: pointer;
}

.pagination {
  margin: 20px auto 0;
  text-align: center;
}

.span {
  color: #000;
  font-size: 16px;
}

// 弹出框样式
.tanchukuang {
  padding: 10px;

  div {
    display: flex;

    div {
      width: 50%;
      margin: 10px;

      span:nth-child(1) {
        width: 100px;
        text-align: right;
      }
    }
  }
}

// 导出（沿用 export 类名，绿色样式由 export-excel 叠加）
.export {
  width: 90px;
  min-width: 90px;
  height: 32px;
  border-radius: 4px;
  text-align: center;
  line-height: 32px;
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
}

.users span {
  margin-left: 30px;
}

.user-cny-mes-panel {
  width: 100%;
}

.user-cny-id-line {
  margin-bottom: 18px;
  color: #606266;
  font-size: 16px;
}

.user-cny-mes-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(110px, 1fr));
  column-gap: 12px;
  row-gap: 16px;
  overflow-x: auto;
  margin-top: 20px;
}

.user-cny-mes-cell {
  text-align: center;
  white-space: nowrap;
  color: #606266;
  line-height: 28px;
}

.user-cny-mes-values .user-cny-mes-cell {
  color: #303133;
  font-size: 16px;
}

</style>
<style>
.el-table .el-table_row-red {
  background: rgba(250, 181.5, 181.5, 1) !important;
}

.el-table .el-table_row-red.hover-row .el-table__cell {
  background: rgba(250, 181.5, 181.5, 1) !important;
}
</style>
